import { defineComponent as _defineComponent } from 'vue'
import NavigationBar from "@/components/shared/NavigationBar.vue";
import Page from "@/components/shared/Page.vue";

import router from "@/router/index";
import { useServiceStore } from "@/stores/serviceStore";
import { useUserStore } from "@/stores/userStore";
import { RouterName } from "@/types";

import { computed, ref } from "vue";
import ChangePasswordForm from "./ChangePasswordForm.vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "ChangeExpiredPassword",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();

/** 현재 페이지로 넘어오게된 방법 구분을 위한 값 */
const source = route.query.source?.toString() ?? "";

const serviceStore = useServiceStore();
const userStore = useUserStore();
const userId = ref("");
userId.value = userStore.loginId ?? "";

const passwordChangeCycleDays = computed(
  () => serviceStore.serviceInfo?.passwordChangeCycleDays ?? 90
);

const goToMainLogin = () => {
  router.replace({ name: RouterName.MainLogin });
};

const __returned__ = { route, source, serviceStore, userStore, userId, passwordChangeCycleDays, goToMainLogin, NavigationBar, Page, ChangePasswordForm }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})